module.exports = __webpack_public_path__ + "img/9788983946850.8f54f0ef.jpg";